// extracted by mini-css-extract-plugin
module.exports = {"buttonCol":"ProductCatalogueAddToCart_buttonCol__266sW","buttonRow":"ProductCatalogueAddToCart_buttonRow__1fGG8","orderButton":"ProductCatalogueAddToCart_orderButton__1Vdp4"};